import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

import { makeQueryString } from '../../util';
import * as User from './User';

export type V = {
  '@id': string;
  '@type': 'DesignResource';
  id: string;
  title: string;
  link: string;
  category: string | null;
  createdBy: User.BaseView | null;
  createdAt: string;
  updatedAt: string;
};

export type W_Create = {
  company: string;
  title: string;
  link: string;
  category: string | null;
};

export type W_Update = {
  title: string;
  link: string;
  category: string | null;
};

export function useReadCollectionListCompanySub(
  companyId: string,
  queryParams?: { page?: number },
  options?: ReadConfig
) {
  return useApiRead<HydraCollection<V>>(
    `/companies/${companyId}/design-resources${makeQueryString(queryParams)}`,
    options
  );
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<V>(`/design-resources/${id}`, options);
}
